import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M21.25 14.5a.75.75 0 0 1 .75.75v4A2.75 2.75 0 0 1 19.25 22H4.75A2.75 2.75 0 0 1 2 19.25v-4a.75.75 0 0 1 1.5 0v4a1.25 1.25 0 0 0 1.25 1.25h14.5a1.25 1.25 0 0 0 1.25-1.25v-4a.75.75 0 0 1 .75-.75" />
    <path d="M12 2.25a.75.75 0 0 1 .75.75v10.19l3.72-3.72a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 1 1 1.06-1.06l3.72 3.72V3a.75.75 0 0 1 .75-.75" />
  </>
);

const DownloadAlt = Icon('download-alt', svgContents);

export default DownloadAlt;
